import type {
    IAngularServices,
    TAngularServiceKeys
} from '~/types/angular.types';
import { observable, action } from 'mobx';

export class InjectorService {
    @observable injector: angular.auto.IInjectorService;

    @action
    setInjector(injector: angular.auto.IInjectorService) {
        this.injector = injector;
    }

    get<T extends TAngularServiceKeys>(dependencyName: T) {
        return this.injector?.get(dependencyName) as IAngularServices[T];
    }
}
